<script setup lang="ts">
import type { RegionTileProps } from '.';

import { cn } from '@/utils';
import { useEvents } from '~/composables/events/useEvents';
import { MixpanelProps } from '~/core/service/mixpanel';
import { computed } from 'vue';

const props = defineProps<RegionTileProps>();

const { trackCardNeighborhoodClicked } = useEvents();
const route = useRoute();

const getTileSpanClass = computed(() => {
	return props.position && props.position <= 3
		? 'xl:col-span-4'
		: 'xl:col-span-3';
});

const handleTileClick = () => {
	trackCardNeighborhoodClicked({
		[MixpanelProps.CURRENT_PAGE]: route.fullPath,
		[MixpanelProps.SECTION_NAME]: 'neighborhoods',
		[MixpanelProps.CARD_POSITION]: props.position ?? 0,
		[MixpanelProps.DESTINATION_URL]: String(props.href),
		[MixpanelProps.NEIGHBORHOOD_NAME]: props.name
	});
};
</script>

<template>
	<NuxtLink
		:to="href"
		:class="cn('col-span-12 md:col-span-6', getTileSpanClass)"
		@click="handleTileClick"
	>
		<div
			class="relative flex h-60 items-center justify-center bg-cover px-6 py-4 md:h-65"
		>
			<NuxtImg
				:src="image"
				width="600"
				height="260"
				sizes="xs:375px sm:320px md:384px lg:480px xl:600px"
				densities="x1"
				format="webp"
				class="absolute inset-0 size-full object-cover"
				loading="lazy"
			/>
			<div
				class="absolute inset-0 bg-[linear-gradient(180deg,rgba(0,0,0,0.32)_0%,rgba(0,0,0,0.32)_50%,rgba(0,0,0,0.5)_100%)] bg-size-[200%_200%] transition-[background-position] duration-300 hover:bg-bottom"
			></div>
			<span
				class="relative text-center font-matter-sq text-2xl font-normal tracking-[-0.03rem] text-white"
			>
				{{ name }}
			</span>
		</div>
	</NuxtLink>
</template>
